import { render, staticRenderFns } from "./UnlockedStdModal.vue?vue&type=template&id=da85129a&"
import script from "./UnlockedStdModal.vue?vue&type=script&lang=js&"
export * from "./UnlockedStdModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports